<script>
    import VolumeCandle from './primitives/volume_candle.js'
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'VolumeCandles',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'TradingCandle',
                    version: '1.1.0',
                    desc: 'Volume Candlestick Chart',
                    preset: {
                        name: 'VolumeCandles',
                        side: 'onchart',
                        settings: {
                            colorCandleUp: '#23a776',
                            colorCandleDw: '#e54150',
                            colorWickUp: '#666666',
                            lineWidth: 1
                        }
                    }
                }
            },
            init() {},
            draw(ctx) {
                let layout = this.$props.layout

                if (this.$props.sub === this.$props.data) {
                    var candles = layout.candles
                } else {
                    candles = layout_cnv(this).candles
                }

                // Calculate volume range for opacity mapping
                let maxVol = 0
                let minVol = Infinity
                for (var i = 0, n = candles.length; i < n; i++) {
                    let v = candles[i].raw[5] || 0
                    if (v > maxVol) maxVol = v
                    if (v < minVol) minVol = v
                }
                let volRange = maxVol - minVol || 1

                for (var i = 0, n = candles.length; i < n; i++) {
                    let ratio = ((candles[i].raw[5] || 0) - minVol) / volRange
                    new VolumeCandle(this, ctx, layout, candles[i], ratio)
                }
            },
            use_for() { return ['VolumeCandles'] },
            y_range() {
                var hi = -Infinity, lo = Infinity
                for (var i = 0, n = this.sub.length; i < n; i++) {
                    let x = this.sub[i]
                    if (x[2] > hi) hi = x[2]
                    if (x[3] < lo) lo = x[3]
                }
                return [hi, lo]
            }
        },
        computed: {
            sett() { return this.$props.settings },
            upColor() { return this.sett.colorCandleUp || this.$props.colors.candleUp || '#23a776' },
            downColor() { return this.sett.colorCandleDw || this.$props.colors.candleDw || '#e54150' },
            wickColor() { return this.sett.colorWickUp || this.$props.colors.wickUp || '#666666' },
            lineWidth() { return this.sett.lineWidth || 1 }
        }
    }
</script>
